import { render, staticRenderFns } from "./NewAcctRequest.vue?vue&type=template&id=6c6e30fd&scoped=true&"
import script from "./NewAcctRequest.vue?vue&type=script&lang=js&"
export * from "./NewAcctRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewAcctRequest.vue?vue&type=style&index=0&id=6c6e30fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e30fd",
  null
  
)

export default component.exports